import { FC } from 'react';
import { Form } from '@repo-level/core-front';

import { FormGroup } from 'components/form/groups/FormGroup';
import { Input } from 'components/form/Input';
import { required } from 'helpers/validators';
import { OfUnion } from 'types/common';

export const FieldText: FC<
  | OfUnion<Form.MethodField>[Form.MethodFieldType.CardHolder]
  | OfUnion<Form.MethodField>[Form.MethodFieldType.Text]
  | OfUnion<Form.MethodField>[Form.MethodFieldType.CashoutCryptoAddress]
> = ({ fieldName, label, proposedValue }) => {
  return (
    <FormGroup title={label || fieldName}>
      <Input
        field={fieldName}
        initialValue={proposedValue || undefined}
        validate={required}
      />
    </FormGroup>
  );
};
